import { AppColors } from "@/styles/colors";
import { Box, Flex, Text } from "@chakra-ui/react";

interface Props {
  label: string;
  /** "left" muestra el texto a la izquierda con la línea extendiéndose a la derecha (default).
   *  "center" muestra el texto centrado con líneas a ambos lados. */
  align?: "left" | "center";
}

export const SectionDividerLabel = ({ label, align = "left" }: Props) => (
  <Flex alignItems="center" gap="8px" marginTop="4px">
    <Box
      flexShrink={0}
      w={align === "left" ? "12px" : undefined}
      flex={align === "center" ? "1" : undefined}
      borderTop={`1px solid ${AppColors.WHITE_BORDER_1}`}
    />
    <Text fontSize="12px" fontWeight={600} color={AppColors.GRAY_TEXT} whiteSpace="nowrap">
      {label}
    </Text>
    <Box flex="1" borderTop={`1px solid ${AppColors.WHITE_BORDER_1}`} />
  </Flex>
);
